var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M7 11.762a4.75 4.75 0 1 0 0-9.5 4.75 4.75 0 0 0 0 9.5Z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 11h2v3H6zM6 0h2v3H6z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.122 10.535 1.414-1.414 2.121 2.122-1.414 1.414zM1.343 2.757l1.415-1.414 2.12 2.121L3.466 4.88z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.465 9.121 1.414 1.415-2.121 2.121-1.415-1.414zM11.243 1.343l1.414 1.414-2.121 2.122-1.414-1.414z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 6v2H0V6zM14 6v2h-3V6z"
  })))));
};
export default SvgSettings;